import { forEach } from 'lodash';
import { BODY_TYPE_FILTER_CATEGORY } from '../../../core/reducers/vehicleListFilters';
const getModelCardsByBodyType = (modelCards) => {
    if (!Array.isArray(modelCards) && !modelCards)
        return undefined;
    const result = {};
    forEach(modelCards, card => {
        const bodyTypes = card.filters[BODY_TYPE_FILTER_CATEGORY] || [];
        forEach(bodyTypes, bodyType => {
            var _a;
            if (!result[bodyType]) {
                result[bodyType] = [card];
            }
            else {
                (_a = result[bodyType]) === null || _a === void 0 ? void 0 : _a.push(card);
            }
        });
    });
    return result;
};
export default getModelCardsByBodyType;
